<template>
  <v-card v-if="rows.length" class="country-card">
    <v-card-title class="country-card__title">
      Umsatz je Land
      <span class="country-card__hint">Versand-Land der Orders — Daten ab Aktivierung des Länder-Trackings</span>
    </v-card-title>
    <v-card-text>
      <div v-for="row in rows" :key="row.country" class="country-card__row">
        <span class="country-card__flag">{{ flag(row.country) }} {{ row.country }}</span>
        <div class="country-card__bar-track">
          <div
            class="country-card__bar"
            :style="{ width: row.share + '%', background: barColor(row.share) }"
          />
        </div>
        <span class="country-card__value">{{ formatEuro(row.revenue) }}</span>
        <span class="country-card__orders">{{ row.orders }} Orders</span>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { getDecimalNumberString } from "@/utils";

export default {
  name: "CountryRevenueCard",
  props: {
    shops: { type: Array, default: () => [] },
  },
  computed: {
    rows() {
      const byCountry = {};
      for (const shop of this.shops) {
        for (const [country, revenue] of Object.entries(shop.revenue?.byCountry || {})) {
          if (!byCountry[country]) byCountry[country] = { revenue: 0, orders: 0 };
          byCountry[country].revenue += revenue || 0;
        }
        for (const [country, orders] of Object.entries(shop.ordersByCountry || {})) {
          if (!byCountry[country]) byCountry[country] = { revenue: 0, orders: 0 };
          byCountry[country].orders += orders || 0;
        }
      }
      const entries = Object.entries(byCountry)
        .map(([country, data]) => ({ country, ...data }))
        .sort((a, b) => b.revenue - a.revenue);
      const max = entries[0]?.revenue || 1;
      return entries.map((entry) => ({
        ...entry,
        share: Math.max(2, Math.round((entry.revenue / max) * 100)),
      }));
    },
  },
  methods: {
    flag(cc) {
      if (!/^[A-Z]{2}$/.test(cc)) return "🌐";
      return String.fromCodePoint(...[...cc].map((c) => 0x1f1e6 + c.charCodeAt(0) - 65));
    },
    /** Sequentiell: eine Hue, mehr Umsatz = dunkler */
    barColor(share) {
      if (share > 66) return "#256abf";
      if (share > 33) return "#5598e7";
      return "#86b6ef";
    },
    formatEuro(value) {
      return `${getDecimalNumberString(value || 0, 2)} €`;
    },
  },
};
</script>

<style lang="scss" scoped>
.country-card {
  border-radius: 12px !important;
  height: 100%;

  &__title {
    font-size: 16px;
    font-weight: 700;
    padding-bottom: 8px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  &__hint {
    font-size: 11px;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.4);
  }

  &__row {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 8px;
  }

  &__flag {
    width: 58px;
    font-size: 13px;
    font-weight: 600;
    flex-shrink: 0;
  }

  &__bar-track {
    flex: 1;
    background: #eef0f3;
    border-radius: 4px;
    height: 14px;
    overflow: hidden;
  }

  &__bar {
    height: 100%;
    border-radius: 4px 3px 3px 4px;
    transition: width 0.3s ease;
  }

  &__value {
    width: 110px;
    text-align: right;
    font-variant-numeric: tabular-nums;
    font-size: 12.5px;
    font-weight: 600;
    flex-shrink: 0;
  }

  &__orders {
    width: 76px;
    text-align: right;
    font-size: 11.5px;
    color: rgba(0, 0, 0, 0.45);
    flex-shrink: 0;
  }
}
</style>
